export default function RightArrow({className}) {
  return <svg className={className} width="11" height="17" viewBox="0 0 11 17" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.485 0l8.486 8.485-8.486 8.486" stroke="currentColor" fill="none" fillRule="evenodd"/>
  </svg>
}



// WEBPACK FOOTER //
// ./components/fullscreen/rightArrow.js